import React from 'react';
import { Button } from './ui/button';
import { WATCHER_COPY } from '../constants/watchSession';

interface WatcherStatusProps {
  /** Close the watcher's sockets and return to the start screen. */
  onLeave: () => void;
}

/**
 * Shown instead of the owner's controls while the user watches someone else's
 * call (owner decision 2026-10-03): only Leave, which ends nothing for anyone
 * else. The header's row 1 ("Live · Observer : {name}") names the call and
 * says it is watched (owner, 2026-10-07). It sits in the session controls
 * row, where the owner's buttons would be (macOS "Stop Watching").
 */
const WatcherStatus: React.FC<WatcherStatusProps> = ({ onLeave }) => (
  <Button variant="secondary" size="sm" onClick={onLeave}>
    {WATCHER_COPY.leave}
  </Button>
);

export default WatcherStatus;
